import { React, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/image/logo.svg";
import Toncoin from "../assets/image/toncoin.svg";
import SCoin from "../assets/image/S-coint.svg";
import "./style/Header.css";

import BaseModal from "./BaseModal";
import CustomSliderSwitch from "./CustomSliderSwitch";
import FloatingInput from "./FloatingInput";
import TopUpTypeSelector from "./TopUpSelector";

import Crypto from "../assets/image/payment/crypto.svg";
import Card from "../assets/image/payment/card.svg";
import SBP from "../assets/image/payment/sbp.svg";

import { Trans } from "react-i18next";

export default function Header() {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const [activeIndex, setActiveIndex] = useState(0);

  const [tonAmount, setTonAmount] = useState("");
  const [sAmount, setSAmount] = useState("");

  const topUpTypes = [
    { id: "card", label: <Trans i18nKey="top-up-modal.card" />, fee: 0.12, bg: Card },
    { id: "sbp", label: <Trans i18nKey="top-up-modal.sbp" />, fee: 0.12, bg: SBP },
    { id: "crypto", label: <Trans i18nKey="top-up-modal.crypto" />, fee: 0.02, bg: Crypto },
  ];

  const [selectedType, setSelectedType] = useState(topUpTypes[0]);

  return (
    <>
      <header className="header">
        <div className="header__content">
          <div className="header__logo">
            <Link to="/">
              <img src={Logo} alt="Logo" />
            </Link>
          </div>

          <div className="header__items">
            <div className="header__balance">
              <button className="header_topup_balance" onClick={openModal}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                  <path d="M10.6248 4.16699C10.6248 3.82181 10.345 3.54199 9.99984 3.54199C9.65466 3.54199 9.37484 3.82181 9.37484 4.16699V9.37533H4.1665C3.82133 9.37533 3.5415 9.65515 3.5415 10.0003C3.5415 10.3455 3.82133 10.6253 4.1665 10.6253H9.37484V15.8337C9.37484 16.1788 9.65466 16.4587 9.99984 16.4587C10.345 16.4587 10.6248 16.1788 10.6248 15.8337V10.6253H15.8332C16.1783 10.6253 16.4582 10.3455 16.4582 10.0003C16.4582 9.65515 16.1783 9.37533 15.8332 9.37533H10.6248V4.16699Z" fill="white"/>
                </svg>
              </button>

              <div className="header_balance_items">
                <img src={Toncoin} alt="toncoin" />
                <span style={{ marginRight: "6px" }}>1,158.514</span>
                <img src={SCoin} alt="s-coin" />
                <span>548</span>
              </div>
            </div>

            <img className="header__avatar" src="/images/fake-avatar.png" alt="avatar" />
          </div>
        </div>
      </header>

      {/* Модалка */}
      <BaseModal
        headerName={<Trans i18nKey="top-up-modal.header" />}
        show={modalOpen}
        onClose={closeModal}
      >
        <CustomSliderSwitch
          options={[
            { label: "TON", icon: Toncoin },
            { label: "Stars Coin", icon: SCoin },
          ]}
          initialIndex={0}
          onChange={(i) => setActiveIndex(i)}
        />

        {/* TON FORM */}
        {activeIndex === 0 && (
          <form style={{ width: "100%" }}>
            <button id="connect-ton-wallet" className="empty-button big">
              <svg className="white-svg svg-24-24" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.75 2.49976C19.75 2.08554 19.4142 1.74976 19 1.74976C18.5858 1.74976 18.25 2.08554 18.25 2.49976V3.74976H17C16.5858 3.74976 16.25 4.08554 16.25 4.49976C16.25 4.91397 16.5858 5.24976 17 5.24976H18.25V6.49976C18.25 6.91397 18.5858 7.24976 19 7.24976C19.4142 7.24976 19.75 6.91397 19.75 6.49976V5.24976H21C21.4142 5.24976 21.75 4.91397 21.75 4.49976C21.75 4.08554 21.4142 3.74976 21 3.74976H19.75V2.49976Z" fill="currentColor"/>
                <path d="M17.25 11.9998C17.25 11.5855 17.5858 11.2498 18 11.2498H19C19.4142 11.2498 19.75 11.5855 19.75 11.9998C19.75 12.414 19.4142 12.7498 19 12.7498H18C17.5858 12.7498 17.25 12.414 17.25 11.9998Z" fill="currentColor"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M15 4.74976C15 4.33554 14.6642 3.99976 14.25 3.99976H6C3.79086 3.99976 2 5.79062 2 7.99976V15.9998C2 18.2089 3.79086 19.9998 6 19.9998H18C20.2091 19.9998 22 18.2089 22 15.9998V8.74976C22 8.33554 21.6642 7.99976 21.25 7.99976C21.2106 7.99976 21.1718 8.0028 21.1341 8.00866C21.0902 8.00279 21.0455 7.99976 21 7.99976H18C15.7909 7.99976 14 9.79062 14 11.9998C14 14.2089 15.7909 15.9998 18 15.9998L20.5 15.9998C20.5 17.3805 19.3807 18.4998 18 18.4998H6C4.61929 18.4998 3.5 17.3805 3.5 15.9998V7.99976C3.5 6.61904 4.61929 5.49976 6 5.49976H14.25C14.6642 5.49976 15 5.16397 15 4.74976ZM18 9.49976H20.5V14.4998H18C16.6193 14.4998 15.5 13.3805 15.5 11.9998C15.5 10.619 16.6193 9.49976 18 9.49976Z" fill="currentColor"/>
                <path d="M7.1233 7.25996C6.71472 7.19186 6.3283 7.46788 6.2602 7.87646C6.19211 8.28503 6.46812 8.67145 6.8767 8.73955L9.2191 9.12995C9.73614 9.21612 10.2639 9.21612 10.7809 9.12995L13.1233 8.73955C13.5319 8.67145 13.8079 8.28503 13.7398 7.87646C13.6717 7.46788 13.2853 7.19186 12.8767 7.25996L10.5343 7.65036C10.1805 7.70932 9.81946 7.70932 9.4657 7.65036L7.1233 7.25996Z" fill="currentColor"/>
              </svg>
              {<Trans i18nKey="top-up-modal.connect-ton-button" />}
            </button>

            <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "20px" }}>
              <FloatingInput
                label={<Trans i18nKey="top-up-modal.input-label" />}
                value={tonAmount}
                onChange={setTonAmount}
                icon={Toncoin}
              />

              <div className="top-up-variant-button-wrapper">
                {[5, 10, 25, 50, 100, 200].map((val) => (
                  <button
                    key={val}
                    type="button"
                    className={
                      "top-up-variant-button" +
                      (tonAmount === val.toString() ? " active" : "")
                    }
                    onClick={() => setTonAmount(val.toString())}
                  >
                    {val}
                  </button>
                ))}
              </div>
            </div>

            <button
              type="submit"
              className="default-blue-button"
              disabled={!tonAmount}
              style={{ marginTop: "20px" }}
            >
              <Trans i18nKey="top-up-modal.send-by-address" />
            </button>
          </form>
        )}

        {/* Stars Coin FORM */}
        {activeIndex === 1 && (
          <form style={{ width: "100%" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "20px" }}>
              <FloatingInput
                label={<Trans i18nKey="top-up-modal.input-label" />}
                value={sAmount}
                onChange={setSAmount}
                icon={SCoin}
              />

              <div className="top-up-variant-button-wrapper">
                {[100, 300, 500, 1000, 2000, 5000].map((val) => (
                  <button
                    key={val}
                    type="button"
                    className={
                      "top-up-variant-button" +
                      (sAmount === val.toString() ? " active" : "")
                    }
                    onClick={() => setSAmount(val.toString())}
                  >
                    {val}
                  </button>
                ))}
              </div>

              <span className="text-mini">1 ₽ ~ 1 Stars Coin</span>
            </div>
            
            <TopUpTypeSelector
              types={topUpTypes}
              value={selectedType}
              onChange={setSelectedType}
            />
            
            <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "20px"}}>
              <span className="text-mini">
                <Trans i18nKey="top-up-modal.payment-text" values={{ amount: sAmount ?? 0, price: (sAmount * (1 + selectedType.fee)).toFixed(2) ?? 0 }} />
              </span>
              <button
                type="submit"
                className="default-blue-button"
                disabled={!sAmount}
              >
                <Trans i18nKey="top-up-modal.top-up-button" />
              </button>
            </div>
          </form>
        )}
      </BaseModal>
    </>
  );
}
